import BaseService from '../core/service/BaseService';

const url = 'metas';
class MetaService extends BaseService {
    async cancelarMeta({ id, descMotivoCancelamento }) {
        const response = await window.$http.patch(`${url}/cancelar/${id}`, {
            descMotivoCancelamento,
        });
        return response;
    }
    async enviarAnalise({ id }) {
        const response = await window.$http.patch(`${url}/enviar-analise/${id}`);
        return response;
    }
    async beforeExport({ body }) {
        return {
            ...body,
            properties: {
                orientation: 'PORTRAIT',
            },
        };
    }
}

export default new MetaService(url);
